import {
  Component,
  Element,
  Listen,
  Method,
  State,
  Event,
  EventEmitter,
} from '@stencil/core';
import { versionComponent } from '../../../global/inject-dependencies';

@Component({
  tag: 'ui-offcanvas-provider',
  styleUrl: 'ui-offcanvas-provider.css',
})
export class UiOffcanvasProvider {
  @Element() el: HTMLUiOffcanvasProviderElement;

  @State() offcanvasElements: HTMLUiOffcanvasPanelElement[] = [];

  @Event({ eventName: 'uiOffcanvasProviderUpdate' }) updateEvent: EventEmitter;

  @Listen('offcanvasTrigger', { target: 'window' })
  onOffcanvasTrigger(event: CustomEvent<{ id: string }>) {
    const offcanvasToOpen = this.offcanvasElements.find(
      (offcanvas) => offcanvas.id === event.detail.id
    );
    const bodyWidth = document.body.getBoundingClientRect().width;
    if (!offcanvasToOpen.hasAttribute('open')) {
      offcanvasToOpen.setAttribute('open', '');
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.maxWidth = `${bodyWidth}px`;
      this.updateEvent.emit({
        id: event.detail.id,
        open: true,
        trigger: event,
      });
    } else {
      offcanvasToOpen.removeAttribute('open');
      document.body.style.height = 'auto';
      document.body.style.overflow = 'visible';
      document.body.style.maxWidth = 'none';
      this.updateEvent.emit({
        id: event.detail.id,
        open: false,
        trigger: event,
      });
    }
  }

  // fallback event used by ui-offcanvas-panel to register itself if it cannot access the provider
  @Listen('offcanvasRegister', { target: 'window' })
  onOffcanvasRegister(event: CustomEvent<{ el: HTMLUiOffcanvasPanelElement }>) {
    this.registerOffcanvas(event.detail.el);
  }

  @Method()
  async registerOffcanvas(offcanvasElement: HTMLUiOffcanvasPanelElement) {
    const index = this.offcanvasElements.findIndex(
      (el) => el.id === offcanvasElement.id
    );

    // if the offcanvas panel is registered, replace it with the current DOM element
    if (index === -1) {
      this.offcanvasElements.push(offcanvasElement);
    } else {
      this.offcanvasElements.splice(index, 1, offcanvasElement);
    }
  }
}

versionComponent(UiOffcanvasProvider);
